import { Component, EventEmitter, OnInit } from '@angular/core';
import { DwButtonCommand, DwButtonConfig, DwModalConfig, DwModalHandler, DwModalResult } from '@devwareapps/devware-cap';
import { Observable, of } from 'rxjs';
import { AcsTestPortionEntity } from '../../../../meta-data/app-meta-data.service';
import { PoaPdfOptionsModalData, PoaPdfOptionsModalResult } from '../../models/poa-pdf-options.model';

@Component({
  selector: 'app-poa-print-options-modal',
  templateUrl: './poa-print-options-modal.component.html',
  styleUrls: ['./poa-print-options-modal.component.scss']
})
export class PoaPrintOptionsModalComponent implements OnInit, DwModalHandler {
  modalConfig: DwModalConfig<PoaPdfOptionsModalData>;
  closeModal = new EventEmitter<DwModalResult<PoaPdfOptionsModalResult>>();

  acsTestPortions: AcsTestPortionEntity[] = [];
  selectedMode: 'all' | 'selected' = 'all';
  selectedAcsTestPortionIds: { [acsTestPortionId: number]: boolean } = {};

  ngOnInit(): void {
    this.acsTestPortions = this.modalConfig?.data?.acsTestPortions || [];

    for (const portion of this.acsTestPortions) {
      if (portion.AcsTestPortionId) {
        this.selectedAcsTestPortionIds[portion.AcsTestPortionId] = true;
      }
    }
  }

  buttonClick(buttonConfig: DwButtonConfig): Observable<DwModalResult<PoaPdfOptionsModalResult>> {
    const result = new DwModalResult<PoaPdfOptionsModalResult>();

    switch (buttonConfig.command) {
      case DwButtonCommand.ok:
      case DwButtonCommand.save:
      case DwButtonCommand.saveAndClose:
        if (this.selectedMode === 'selected' && !this.hasSelectedPortions()) {
          result.closeModal = false;

          return of(result);
        }

        result.data = {
          acsTestPortionIds: this.selectedMode === 'selected'
            ? this.getSelectedAcsTestPortionIds()
            : []
        };
        result.closeModal = true;
        break;

      case DwButtonCommand.cancel:
        result.cancelled = true;
        result.closeModal = true;
        break;
    }

    return of(result);
  }

  hasSelectedPortions(): boolean {
    return this.getSelectedAcsTestPortionIds().length > 0;
  }

  private getSelectedAcsTestPortionIds(): number[] {
    return Object.keys(this.selectedAcsTestPortionIds)
      .filter(id => this.selectedAcsTestPortionIds[+id])
      .map(id => +id);
  }

}
